import { formatEnum } from "@/utils/formatEnum"
import { anyProp, defineComponent, type Component, type ReactiveComponent } from "vue-utils"
import type { GenericDisplayProps } from "./DisplayComponent"

export function createEnumDisplay<T extends string>(): Component<GenericDisplayProps<T>> {
	type Props = GenericDisplayProps<T>

	const EnumDisplay: ReactiveComponent<Props> = (props) => {
		return () => (props.value ? formatEnum(props.value) : "")
	}

	return defineComponent(EnumDisplay, {
		value: anyProp(),
	})
}
